import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import * as moment from "moment";
import i18next from "i18next";
import axios from "axios";
import {
  useParams,
  useNavigate,
  useSearchParams,
  useLocation,
} from "react-router-dom";
import { WarningPopUp } from "hesus-ui-kit";
import Header from "./components/Header/Header";
import RelatedContactList from "../../RelatedContact/RelatedContactList";
import GeneralInfo from "./components/GeneralInfo";
import KickOffView from "../../KickOff/KickOffView/KickOffView";
import MeetingReportsList from "../../MeetingReports/MeetingReportsList";
import AnalyticalNotesList from "../../AnalyticalNotes/AnalyticalNotesList/AnalyticalNotesList";
import DocumentListView from "../../Document/DocumentList/DocumentListView";
import EnquiryList from "../../Enquiry/EnquiryList";
import EnquiryView from "../../Enquiry/EnquiryView";
import QuoteView from "../../Quote/QuoteView";
import QuoteList from "../../Quote/QuoteList";
import DisputeList from "../../Dispute/DisputeList";
import SummaryList from "../../Summary/SummaryList/SummaryList";
import PurchaseOrderList from "@modules/PurchaseOrder/PurchaseOrderList/PurchaseOrderList";
import GeneralPlanningList from "../../Planning/GeneralPlanningList/GeneralPlanningList";
import InvoiceList from "@modules/Invoice/InvoiceList";
import {
  SiteViewContainer,
  FlexRow,
  SectionContainer,
} from "./SiteView.styled";
import "./SiteView.scss";
import { loadSingleSite } from "../SiteList/SiteList.actionCreators";
import { TABLE_MEETING_REPORTS_LIST_WITH_BUTTON } from "@utils/constants";
import NotFound from "@components/Errors/NotFound";
import { setSingleSiteNotFound } from "../SiteList/SiteList.slice";
import { setSingleEnquiryNotFound } from "@modules/Enquiry/EnquiryList/EnquiryList.slice";
import { setSingleQuoteNotFound } from "@modules/Quote/QuoteList/QuoteList.slice";
/**
 * site GeneralInfo,
 * Path - /site/view/{id}
 * @see See [CenterProduct Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/2944335881/Site+view+page+-+General+layout)
 * @component
 */
const SiteView = (props) => {
  const { t } = props;
  const params = useParams();

  const validPaths = [
    "general-info",
    "contacts",
    "documents",
    "meeting-reports",
    "analytical-notes",
    "quotes",
    "enquiry",
    "dispute",
    "planning",
    "summary",
    "invoices",
    "purchase-orders",
    "kickoff",
    "quote-create",
  ];
  const isValidPath =
    (validPaths.includes(params.path) ||
    /^enquiry-view-\d+$/.test(params.path) ||
    /^quote-view-\d+$/.test(params.path) ||
    /^quote-edit-\d+$/.test(params.path));

  const location = useLocation();
  const basePath = location.pathname.split("/").slice(0, 3).join("/") + "/";

  const [siteData, setSiteData] = useState([]);
  const [isConfirmVisible, setConfirmVisibility] = useState(false);

  const [confirmationBoxTitle, setConfirmationBoxTitle] = useState(
    "COMPANY_CONFIRMATION_BOX_DELETE"
  );
  const [confirmationBoxContent, setConfirmationBoxContent] = useState(
    "COMPANY_CONFIRMATION_BOX_DELETE_CONTENT"
  );
  const [isConfirm, setActionConfirmStatus] = useState(false);
  const [isRefeshData, setIsRefeshData] = useState(false);

  const dispatch = useDispatch();
  const history = useNavigate();
  const [searchParams] = useSearchParams();
  const siteId = parseInt(params.id, 10);
  const quoteIdFromUrl = searchParams.get("quoteId");

  const selectedSiteData = useSelector((state) => state.siteList.selectedSite);
  const isSingleSiteNotFound = useSelector(
    (state) => state.siteList.isSingleSiteNotFound
  );
  const isSingleEnquiryNotFound = useSelector(
    (state) => state.enquiryList.isSingleEnquiryNotFound
  );
  const isSingleQuoteNotFound = useSelector(
    (state) => state.quoteList.isSingleQuoteNotFound
  );
  useEffect(() => {
    dispatch(setSingleSiteNotFound(false));
    dispatch(setSingleEnquiryNotFound(false));
    dispatch(setSingleQuoteNotFound(false));
    if (
      selectedSiteData !== null &&
      parseInt(siteId, 10) === parseInt(selectedSiteData.id, 10)
    ) {
      setSiteData(selectedSiteData);
    } else fetchSiteInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSiteData]);

  const handleSiteStatus = (status) => {
    if (status === 1) {
      setConfirmationBoxTitle("COMPANY_CONFIRMATION_BOX_ENABLE");
      setConfirmationBoxContent("COMPANY_CONFIRMATION_BOX_ENABLE_CONTENT");
    } else {
      setConfirmationBoxTitle("COMPANY_CONFIRMATION_BOX_DELETE");
      setConfirmationBoxContent("COMPANY_CONFIRMATION_BOX_DELETE_CONTENT");
    }
    setConfirmVisibility(true);
  };

  const onPopUpCancel = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(false);
  };

  const onPopUpConfirm = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(true);
  };

  useEffect(() => {
    if (isConfirm) {
      axios
        .post(
          `/companies/${siteId}/updateStatus`,
          siteData.isActive === 1 ? `0` : 1
        )
        .then((response) => {
          setActionConfirmStatus(false);
          setSiteData(response?.data[0]);
        })
        .catch((error) => handleApiError(error));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfirm]);
  
  const fetchSiteInfo = () => {
    if (!Number.isInteger(siteId) || siteId <= 0) {
      return;
    }
    dispatch(
      loadSingleSite({
        siteId,
      })
    );
  };

  const updateRefeshStatus = () => {
    setIsRefeshData(true);
  };

  useEffect(() => {
    if (isRefeshData) {
      fetchSiteInfo();
      setIsRefeshData(false);
    }
  }, [isRefeshData]);

  let maineWidth = "100%";
  let marginLeft = "0px";
  if (params.path === "kickoff") {
    maineWidth = "auto";
    marginLeft = "inherit";
  }

const isEnquiryPath = params.path.startsWith("enquiry-view-");
const isQuotePath = params.path.startsWith("quote-view-");
  if (
    basePath === "/site/view/" &&
    (
      isSingleSiteNotFound ||
      !isValidPath ||
      (isEnquiryPath && isSingleEnquiryNotFound) ||
      (isQuotePath && isSingleQuoteNotFound))
  ) {
    return <NotFound />;
  }
   
  return (
    <SiteViewContainer
      maineWidth={maineWidth}
      marginLeft={marginLeft}
      className="site-view-enquiry"
    >
      {siteData?.id && (
        <>
          <FlexRow>
            <SectionContainer>
              <Header
                siteData={siteData}
                setSiteData={setSiteData}
                handleSiteStatus={handleSiteStatus}
                setIsRefeshData={setIsRefeshData}
              />
              {params.path === "general-info" && (
                <GeneralInfo
                  site={siteData}
                  siteId={siteData.id}
                  updateRefeshStatus={updateRefeshStatus}
                />
              )}
              {params.path === "contacts" && (
                <RelatedContactList
                  dependancies={JSON.stringify(["roles", "linkedEntities"])}
                  entityType="site"
                  entityId={siteData.id}
                  countryId={siteData.platformCountry.id}
                  // companyId={siteData?.company?.id}
                  headerNotRequired
                  columnList={[
                    "ID",
                    "CONTACT_COMPANY",
                    "CONTACT_NAME",
                    "CONTACT_FUNCTION",
                    "CONTACT_TYPE",
                    "CONTACT_COMMUNICATION",
                    "ACTIONS",
                  ]}
                />
              )}
              {params.path === "documents" && (
                <DocumentListView
                  entityId={parseInt(params.id, 10)}
                  entityType="siteId"
                  type={1}
                  hesusBoxId={parseInt(siteData.boxFolderId, 10)}
                  updateRefeshStatus={updateRefeshStatus}
                />
              )}
              {params.path === "meeting-reports" && (
                <MeetingReportsList
                  type={TABLE_MEETING_REPORTS_LIST_WITH_BUTTON}
                  isHeader="sub-menu"
                  objectType="site"
                  objectId={siteData.id}
                  countryId={siteData.platformCountry.id}
                  columnList={[
                    "ID",
                    "TITLE",
                    "HESUS_PARTICIPANTS",
                    "MEETING_DATE",
                    "ENTITES_LINKED",
                    "RATING",
                    "MEETING_NEXT_DATE",
                    "ACTIONS",
                  ]}
                />
              )}
              {params.path === "kickoff" &&
                parseInt(siteData.koStatus, 10) !== 0 &&
                siteData.koStatus !== null && (
                  <KickOffView
                    objectId={siteData.id}
                    setIsRefeshSiteData={setIsRefeshData}
                    defaultQuoteId={quoteIdFromUrl}
                  />
                )}
              {params.path === "analytical-notes" && (
                <AnalyticalNotesList
                  columnList={[
                    "ID",
                    "STATUS",
                    "CREATED_BY",
                    "CREATION_DATE",
                    "UPDATED_AT",
                    "ACTIONS",
                  ]}
                  siteId={siteData.id}
                />
              )}
              {params.path === "enquiry" && (
                <EnquiryList
                  entityType="site"
                  entityId={siteData.id}
                  page="view"
                  platformCountryId={siteData?.platformCountry?.id}
                  headerNotRequired
                  columnList={[
                    "ID",
                    "CONTACT_COMPANY",
                    "CONTACT_NAME",
                    "CONTACT_FUNCTION",
                    "CONTACT_TYPE",
                    "CONTACT_COMMUNICATION",
                    "ACTIONS",
                  ]}
                />
              )}
              {params.path === "quotes" && (
                <QuoteList
                  dependancies={JSON.stringify(["services"])}
                  entityType="site"
                  entityId={siteData.id}
                  jobsiteNeedKickoff={siteData.needKickoff}
                  setIsRefeshSiteData={setIsRefeshData}
                  sitePlatformCountryCountryId={siteData.platformCountry.id}
                />
              )}
              {params.path.slice(0, 12) === "enquiry-view" && (
                <EnquiryView
                  enquiryId={params.path.split("-")[2]}
                  isRefeshData={isRefeshData}
                  setIsRefeshData={setIsRefeshData}
                />
              )}
              {(params.path.slice(0, 10) === "quote-view" ||
                params.path.slice(0, 12) === "quote-create" ||
                params.path.slice(0, 10) === "quote-edit") && (
                <QuoteView
                  siteData={{
                    id: siteData?.id,
                    name: siteData?.name,
                    platformCountryId: siteData?.platformCountry?.id,
                  }}
                  quoteId={params.path.split("-")[2]}
                  setIsRefeshSiteData={setIsRefeshData}
                  countryId={siteData?.platformCountry?.id}
                  companyId={siteData?.company?.id}
                  jobsiteNeedKickoff={siteData?.needKickoff}
                />
              )}
              {params.path === "planning" && siteData?.id && (
                <GeneralPlanningList
                  siteId={parseInt(params.id, 10)}
                  siteStartDate={
                    siteData?.estimatedStartDate
                      ? moment(
                          siteData?.estimatedStartDate).format("YYYY-MM-DD")
                      : ""
                  }
                  page="site"
                />
              )}
              {params.path === "dispute" && (
                <DisputeList
                  entityId={parseInt(params.id, 10)}
                  entityType="siteId"
                  page="site"
                  platformCountryId={siteData?.platformCountry?.id}
                />
              )}
              {params.path === "summary" && (
                <SummaryList
                  entityId={parseInt(params.id, 10)}
                  countryId={siteData?.platformCountry?.id}
                />
              )}
              {params.path === "purchase-orders" && (
                <PurchaseOrderList
                  entityId={parseInt(params.id, 10)}
                  countryId={siteData?.platformCountry?.id}
                  siteName={siteData?.name}
                  siteOpportunityNumber={siteData?.opportunityNumber}
                  page="site"
                  columnList={[
                    "PURCHASE_ORDER_REFERENCE",
                    "SUPPLIER",
                    "PURCHASE_ORDER_ORDER_DATE",
                    "AMOUNT_EXCL_TAX",
                    "PURCHASE_ORDER_HESUS_CONTACT",
                    "STATUS",
                    "ACTIONS",
                  ]}
                />
              )}
              {params.path === "invoices" && (
                <InvoiceList
                  entityId={parseInt(params.id, 10)}
                  entityType="site"
                  entityPlatformCountryId={siteData?.platformCountry?.id}
                />
              )}
            </SectionContainer>
          </FlexRow>
        </>
      )}
      {isConfirmVisible && (
        <WarningPopUp
          title={t(confirmationBoxTitle)}
          message={t(confirmationBoxContent)}
          onPopUpCancel={onPopUpCancel}
          onPopUpConfirm={onPopUpConfirm}
          ValidateContent={t("YES")}
          CancelContent={t("CANCEL")}
        />
      )}
    </SiteViewContainer>
  );
};
SiteView.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(SiteView);
